<template>
  <div class="screening-trend">
    <div
      v-for="(reference, i) in screeningOutcomeTrend"
      :key="`${reference}-${i}`"
      class="reference-dot"
      :class="reference.screeningOutcomeClass"
    ></div>
  </div>
</template>

<script>
import { RelevanceAssessment } from '@/enums';

const ASSESSMENT_TO_PROPS = {
  [RelevanceAssessment.RELEVANT]: {
    label: 'Relevant',
    color: 'success',
  },
  [RelevanceAssessment.NOT_SURE]: {
    label: 'Not Sure',
    color: 'warning',
  },
  [RelevanceAssessment.NOT_RELEVANT]: {
    label: 'Not Relevant',
    color: 'error',
  },
  [RelevanceAssessment.UNSCREENED]: {
    label: 'Unscreened',
    color: 'grey lighten-3',
  },
};

export default {
  name: 'ScreeningTrendMatrix',
  props: {
    screeningOutcomes: {
      type: Array,
      required: true,
    },
    referenceCount: {
      type: Number,
      required: false,
      default: 40,
    },
  },
  computed: {
    screeningOutcomeTrend() {
      return this.extractOutcomeTrend().concat(
        this.padOutcomeTrend()
      );
    },
  },
  methods: {
    extractOutcomeTrend() {
      return this.screeningOutcomes
        .slice(0, this.referenceCount)
        .map((screeningOutcome) => {
          return {
            screeningOutcomeClass:
              ASSESSMENT_TO_PROPS[screeningOutcome.outcome].color,
          };
        });
    },
    padOutcomeTrend() {
      if (this.referenceCount <= this.screeningOutcomes.length) {
        return [];
      } else {
        if (this.referenceCount > this.screeningOutcomes.length) {
          const padCount =
            this.referenceCount - this.screeningOutcomes.length;

          const paddedTrend = [];
          for (let i = 0; i < padCount; i++) {
            paddedTrend.push({
              screeningOutcomeClass:
                ASSESSMENT_TO_PROPS[RelevanceAssessment.UNSCREENED]
                  .color,
            });
          }
          return paddedTrend;
        }
      }
    },
    mergeCountAndProps(count, assessment) {
      return { count, ...ASSESSMENT_TO_PROPS[assessment] };
    },
  },
};
</script>

<style lang="scss" scoped>
.screening-trend {
  line-height: 0;
}

.reference-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin: 1px;
  line-height: 0;
  border-radius: 50%;
}
</style>
